import { useState } from "react";
import { Check, ChevronDown } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export const FilterSelect = ({ label, icon: Icon, dot, value, options, onChange, testId }) => {
  const [open, setOpen] = useState(false);
  const { t } = useLanguage();
  const current = options.find((o) => o.value === value);
  const isDefault = value === options[0].value;
  return (
    <div className="relative shrink-0 snap-start">
      <button
        type="button"
        data-testid={testId}
        onClick={() => setOpen((o) => !o)}
        className={`flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-medium transition ${
          !isDefault
            ? "border-blue-300 bg-[#EFF6FF] text-[#2563EB]"
            : "border-slate-200 bg-white text-slate-700 hover:border-blue-200"
        }`}
      >
        {dot && <span className="h-2 w-2 rounded-full bg-emerald-500" />}
        {Icon && <Icon className="h-4 w-4 text-slate-400" />}
        {isDefault ? t(label) : t(current?.label)}
        <ChevronDown className={`h-3.5 w-3.5 text-slate-400 transition ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute left-0 z-50 mt-2 w-52 rounded-2xl border border-slate-100 bg-white p-1.5 shadow-xl">
            {options.map((o) => (
              <button
                key={o.value}
                type="button"
                data-testid={`${testId}-option-${o.value}`}
                onClick={() => {
                  onChange(o.value);
                  setOpen(false);
                }}
                className={`flex w-full items-center justify-between rounded-xl px-3 py-2 text-left text-sm transition hover:bg-blue-50 ${
                  value === o.value ? "font-semibold text-[#2563EB]" : "text-slate-700"
                }`}
              >
                {t(o.label)}
                {value === o.value && <Check className="h-4 w-4" />}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
